import styled from 'styled-components';

const StandardReportIncludedFieldsTitleBar = styled.div`
  margin-top: ${(props): string => props.theme.spaces.xl};
  padding-bottom: ${(props): string => props.theme.spaces.md};
  display: flex;
  > div:first-child {
    width: 3rem;
  }
`;

export { StandardReportIncludedFieldsTitleBar };
